import PropTypes from "prop-types"
import React from "react"
import "../../assets/css/normalize.css"
import "../../assets/css/facelift.css"
import Footer from "../footer"
import Header from "../header"
import BlogSidebar from "../blog-sidebar"

const Layout = ({ pageId, children }) => (
  <>
    <div className="home blog" id="page">
      <div id={pageId}>
        <Header />
        <div id="wrap">
          <main>{children}</main>
          <BlogSidebar />
        </div>
        <Footer />
      </div>
    </div>
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
